﻿/* global _, datesObject, angular, analytics_data */
import { analyticsEvent } from '../../controllers/analytics-controller';

var InformaFacetDataController = function ($scope, $rootScope, $location, $http, $anchorScroll, $timeout,  searchService, searchBootstrapper, facetAvailabilityService) {
    "use strict";
    // Bind `this` to vm - a representation of the view model
    var vm = this;

    // General Facet stuff
    vm.facetGroups = searchService.getFacetGroups();
    vm.searchService = searchService;
    vm.location = $location;
    vm.anchorScroll = $anchorScroll;
    vm.searchBootstrapper = searchBootstrapper;
    vm.MaxFacetShow = 5;
    vm.showingOnlySubscriptions = false;
    vm.subscriber_cookie;
    vm.subscriptions;
    vm.enableMySusbriptions = false;
    vm.keywordSearch=false;
    vm.defaultState = true;
    var dataCenterPerPageLimit = document.getElementById("hidDataCenterLimit");    
	$rootScope.$watch('facetAvailability', function () {
        vm.areFacetsDisabled = facetAvailabilityService.facetsAreEnabled();
    });
    vm.themeOmdia = angular.element(document.body).hasClass('theme-omdia');
    vm.originalGroup = [];
    
    $scope.$watch(function () {
        return searchService.getPager();
    }, function () {
        vm.facetGroups = searchService.getFacetGroups();
        vm.originalGroup = vm.searchService.getFacetGroups();
        var elementValue = document.getElementById("hidIncludeSearch").value;
        var contentType = document.getElementById("hidContentType").value;
        var requiredFacets = elementValue.split(',');

        vm.facetGroups = _.filter(vm.facetGroups, function (fg) {
            fg.facets.forEach(function (f) {

                var subListSelected = false;
                if (f.sublist != null) {
                    f.sublist.forEach(function (w) {
                        if (w.selected) {
                            subListSelected = true;
                        }
                    });
                }

                if (f.parentId == "contenttype" && f.id == contentType) {
                    f.selected = true;
                }
            });
            return elementValue.includes(fg.id);
        });

        var tempData = [];
        for (var facetIdx = 0; facetIdx < vm.facetGroups.length; facetIdx++) {
            tempData.push(vm.facetGroups[facetIdx]);
        }
        vm.facetGroups.splice(0, vm.facetGroups.length);
        if (tempData.length > 0) {
            for (var facetIdx = 0; facetIdx < requiredFacets.length; facetIdx++) {
                for (var labelCount = 0; labelCount < requiredFacets.length; labelCount++) {
                    if (tempData[labelCount] && tempData[labelCount].id == requiredFacets[facetIdx]) {
                        vm.facetGroups.splice(facetIdx, 0, tempData[labelCount]);
                    }
                }
            }
        }

        if (vm.facetGroups.length > 0) {
            $(".button-container").show();
            if (jQuery.holdReady)
            jQuery.holdReady(false);
        } else {
            $(".button-container").hide();
            if (jQuery.holdReady)
            jQuery.holdReady(true);
        }
        if (searchService.getNewSearch()) {
            vm.facetGroups = vm.originalGroup;
            searchService._isNewSearch = false;
        }
    }, true);

    jQuery(document).ready(function () {       
            vm.keywordSearch = false;
    });

    vm.updateCookie = function (facetParentId=null) {
        if (vm.subscriptions.length > 0) {
            var subscriptionId = 'publication', issubscriptionChannel = false;;
            _.each(vm.subscriptions, function (channel) {
                var splitName = channel.split("-");
                if (splitName.length > 1) {
                    subscriptionId = splitName[0];
                }
                if (facetParentId == subscriptionId.replace(" ", "").replace("'", "").toLowerCase()) {
                    issubscriptionChannel = true;
                }
            });

            if (issubscriptionChannel) {
                var cookie_facets = [];
                _.each(vm.facetGroups, function (group) {
                    _.each(group.getSelectedFacets(), function (facet) {
                        if (facet && facet.selected) {
                            if (facet.parentId == "publication" && cookie_facets.indexOf(facet.label) === -1) {
                                cookie_facets.push(facet.label.toLowerCase());
                            } else if (facet.parentId != "publication" && cookie_facets.indexOf(facet.parentId + '-' + facet.label) === -1) {
                               var isSubscriber=false;
                                _.each(vm.subscriptions, function (channel) {
                                    var splitName = channel.split("-");
                                    if (splitName.length > 1) {
                                        subscriptionId = splitName[0];
                                    }
                                    if (facet.parentId == subscriptionId.replace(" ", "").replace("'", "").toLowerCase()) {
                                        isSubscriber = true;
                                    }
                                });
                                if(isSubscriber)
                                    cookie_facets.push(facet.parentId + '-' + facet.label);
                            }
                        }
                    });
                });

                if (cookie_facets.length > 0 && vm.enableMySusbriptions && vm.keywordSearch) {
                    vm.createCookie(vm.subscriber_cookie, cookie_facets, 3650);
                }
            }
        }
    };

	var facetsForAnalytics = false;
    //** This updates the router/url with the latest search parameters **//
    vm.update = function (facetGroupId, parentfacet, subfacetId) {
        if(facetGroupId) {
			var facetGroup;
            facetsForAnalytics = false;
			_.each(vm.facetGroups, function(group) {
				if(group.id === facetGroupId) {
					facetGroup = group;
				}
            });

			_.each(facetGroup.getSelectedFacets(), function (facet) {
				if(facet) {
					if(!facetsForAnalytics) {
						facetsForAnalytics = facet.label;
					} else {
						facetsForAnalytics += '|' + facet.label;
                    }                    
				}
            });
        
			var event_data = {
				event_name: 'search_facets',
				search_facet_category: facetGroup.label
			};

			if(facetsForAnalytics) {
				event_data.search_facet = facetGroup.label + ": " + facetsForAnalytics;
			}

			analyticsEvent(	$.extend(analytics_data, event_data) );

		}
		// Disable all facet options while updating search results
		facetAvailabilityService.disableFacets();
        vm.updateFacetToggleState();
        vm.allRegionsFacetsSelected();

        if (parentfacet != null && subfacetId != null) {

            //deselect sublist items and load only one selected sublist item
            vm.searchService.getFacetGroup(parentfacet.parentId).facets.forEach(function (vf) {
                vf.selected = false;
                if (vf.id != parentfacet.id) {
                    vf.sublist.forEach(function (v) {
                        v.selected = false;
                    });
                } else {
                    vf.sublist.forEach(function (v) {
                        if (v.id != subfacetId) {
                            v.selected = false;
                        }
                    });
                }
            });

            vm.facetGroups.forEach(function (fg) {
                if (fg.id == parentfacet.parentId) {
                    fg.facets.forEach(function (pf) {
                        if (pf.id == parentfacet.id) {
                            pf.sublist.forEach(function (sf) {
                                if (sf.id == subfacetId) {
                                    sf.selected = !sf.selected;
                                }
                            })
                        }
                    })
                }
            });
        }

        var params = this.searchService.getRouteBuilder().getRoute().split('&');
     
        _.each(this.facetGroups, function(group) {
            _.each(group.facets, function(facet) {
                _.each(facet.sublist, function(subfacet) {
                    vm.searchService.getFacet(subfacet.id).selected = subfacet.selected;
                });
            });
        });

        vm.searchService.getFilter('page').setValue('1');
        vm.searchService.getFilter('perPage').setValue(dataCenterPerPageLimit.value);
        var routeBuilder = this.searchService.getRouteBuilder();
        vm.location.search(routeBuilder.getRoute());
        vm.searchService.query();
        //Scroll to the top of the results when a new page is chosen
        //vm.location.hash("searchTop");
        //vm.anchorScroll();
    };

    vm.allRegionsFacetsSelected = function() {
        var facetList = this,
            facetGroups = facetList.facetGroups;

            if (vm.themeOmdia) {
              // loop all facets
                _.each(facetGroups, function(group) {
                    var facets = group.facets;
                    _.each(facets, function(facet) {

                      // if facet group is regions or service area
                        if (facet.parentId === 'regions' || facet.parentId === 'dataterms' || facet.parentId === 'periodicity') {

                            if (facet.sublist && facet.sublist.length === 0 && facet.selected) {
                                return;
                            }

                            // vm.allSubFacetSelected = true, if any of the sublist items selected
                            var allRegionsFacetsSelected = facet.sublist && facet.sublist.length > 0 ? 
                                facet.sublist.every(function(itm){ return itm.selected; }) : false;
                            vm.allSubFacetSelected = allRegionsFacetsSelected;

                            // then select parent facet of sublist
                            if (allRegionsFacetsSelected) {
                                facet.selected = true;
                                vm.ParentFacetId =  facet.parentId;
                            } else {
                                facet.selected = false;
                            }
                        }
                    });
                });
            }
    };


    vm.updateTime = function (filter) {
        vm.searchService.getFilter('page').setValue('1');
        var routeBuilder = this.searchService.getRouteBuilder();
        var hash = {};
        var urlQuery = "&";
        var h = decodeURIComponent(routeBuilder.getRoute()).split("&");
        for (var idx in h) {
            if (h[idx] != "") {
                var currentParameter = h[idx].split("=");

                if (currentParameter[0] != "date") {
                    hash[currentParameter[0]] = currentParameter[1];
                    urlQuery = urlQuery + "&" + currentParameter[0] + "=" + currentParameter[1];
                }
            }
        }

        vm.location.search(urlQuery);

        vm.location.hash("searchTop");
        vm.anchorScroll();
    };

    vm.facetChange = function (facet) {
        vm.defaultState = false;
        vm.searchService.getFacetGroup(facet.parentId).getFacet(facet.id).selected = facet.selected;
        vm.selectAllFacet(facet, facet.parentId);
        vm.update(facet.parentId);
        if(vm.keywordSearch && vm.enableMySusbriptions)
           vm.updateCookie(facet.parentId);
        vm.clearAllSetFlag();
    };

    vm.selectAllFacet = function(facet, facetId) {
        var facetList = this,
            facetGroups = facetList.facetGroups;

        if(vm.themeOmdia && facet && (facetId === 'regions' || facetId === 'dataterms' || facetId === 'periodicity') && facet.sublist.length) {
        
            var regionsfacetIndex = facetGroups.findIndex(function (element) {
                return element.id === facetId;
            });
            var selectedFacetIndex = facetGroups[regionsfacetIndex].facets.findIndex(function (element) {
                return element.id === facet.id;
            });
            _.each(facetGroups[regionsfacetIndex].facets[selectedFacetIndex].sublist, function(sublist) {
                sublist.selected = facet.selected;
            });
        }
    };

    vm.clearAllSetFlag = function(){
        if(!vm.themeOmdia){
            return;
        }
        var facetClear = this;
        var isAnyfacetSelected = false;

        var facetGroups = facetClear.facetGroups;
        _.each(facetGroups, function (group) {
            var facets = group.facets;
            _.each(facets, function (facet) {
                if (facet.selected) {
                    isAnyfacetSelected = true;
                    return;
                } else {
                    var facetSublist = facet.sublist;
                    _.each(facetSublist, function (childFacet) {
                        if (childFacet.selected) {
                            isAnyfacetSelected = true;
                            return;
                        }
                    });
                }
            });
        });
        vm.clearAllVisible = isAnyfacetSelected;
    };

    vm.facetClick = function (facet) {
        vm.searchService.getFacetGroup(facet.parentId).facets.forEach(function (v) {
            if (v.id != facet.id) {
                v.selected = false;
                if (v.sublist != null) {
                    v.sublist.forEach(function (w) {
                        w.selected = false;
                    });
                }
            }
        });
        vm.searchService.getFacetGroup(facet.parentId).getFacet(facet.id).selected = !facet.selected;       
        vm.update(facet.parentId);
        if (vm.keywordSearch && vm.enableMySusbriptions) vm.updateCookie(facet.parentId);
    };

    vm.isPartialSelectedfacetGroup = function (group) {
        if (!vm.themeOmdia)
            return false;
        if (group && (group.parentId === 'regions' || group.parentId === 'dataterms' || group.parentId === 'periodicity') && group.sublist.length) {
            var facets = group.sublist;
            var selectedCount = 0;
            var unSelectedCount = 0;
            _.each(facets, function (facet) {
                if (facet.selected) {
                    selectedCount++;
                } else {
                    unSelectedCount++;
                }
            });
            return unSelectedCount > 0 && selectedCount > 0;
        }
        return false;
    };

    vm.updateFacetToggleState = function () {
        var facetShowMore = this;
            var facetGroups = facetShowMore.facetGroups;
            _.each(facetGroups, function (group) {
                if(group.ShowMore) {
                    vm.facetWithShowMore.push(group.id)
                }
                var facets = group.facets;
            _.each(facets, function (facet) {
                if(group.ShowMore) {
                    vm.subFacetWithShowMore.push(facet.id)
                }
            });
        });
    };
    
	// facetGroupId: 'publication'
	// facetIds: ['In Vivo', 'Rose Sheet']
    vm.facetChangeMultiple = function(facetGroupId, facetIds) {

        var facets,
            subfacets = [];
        if (facetIds.length > 0) {

            _.each(vm.facetGroups, function (group) {
                if (group.id === facetGroupId) {
                    facets = group;
                }
            });

            _.each(facets.getSelectedFacets(), function (facet) {
                if (facet) {
                    facet.selected = false;
                }
            });

            _.each(facetIds, function (id) {
                var pubFacets = facets.facets;
                var splitName = id.split("-");
                if (splitName.length > 1) {
                    id = splitName[0];
                }
                _.each(pubFacets, function (pubFac) {
                    var facetId = pubFac.id.replace(" ", "").replace("'", "").toLowerCase();
                    if(facetId === id.replace(" ", "").replace("'", "").toLowerCase()) {
                        pubFac.selected = true;
                    }
                })
            });

            // vm.update(facetGroupId);
            
            _.each(facetIds, function (id) {
                var splitName = id.split("-");
                if (splitName.length > 1) {
                    var parentId = splitName[0].replace(" ", "");
                    var myId = splitName[1].replace("and", "&");
                    _.each(vm.facetGroups, function (group) {
                        if (group.id == parentId) {
                            subfacets = group.facets;
                        }
                    });

                    _.each(subfacets, function (subfac) {
                        if (subfac.id.toLowerCase() == myId.toLowerCase()) {
                            subfac.selected = true;
                        }
                    });
                    
                }
            });
        
            if(vm.enableMySusbriptions && vm.keywordSearch) 
                vm.createCookie(vm.subscriber_cookie,facetIds,3650);

            vm.update();
        } else {
            vm.clearAllFacets();
        }
    };


    // TODO: this comes from a diff search app, and needs jquery to work.
    //       either hook up jq to this controller or move this elsewhere
    vm.scrollTop = function () {
        // var location = jq(".search-facets__header").offset().top;
        //window.scrollTo(0, location - 80);
    };

    vm.hasSelected = function (values) {
        return _.find(values, { selected: true }) ? true : false;
    };

    vm.getFilter = function (filterKey) {
        var filter = vm.searchService.getFilter(filterKey);
        if (!filter) {
            vm.searchBootstrapper.createFilter(filterKey, "");
            filter = vm.searchService.getFilter(filterKey);
        }
        return filter;
    };

    /* This deselects any selected facet checkboxes, clears all facet parameters
        from the search query, and runs the clearDateRange function */
    vm.clearAllFacets = function () {
        var facetClear = this;
        var facetGroups = facetClear.facetGroups;
        _.each(facetGroups, function (group) {
            var facets = group.facets;
            _.each(facets, function (facet) {
                facet.selected = false;
            });
        });
        vm.update();
        if(vm.keywordSearch && vm.enableMySusbriptions)
             vm.createCookie(vm.subscriber_cookie, [], 3650);
    };

    vm.clearFilter = function (filterKey) {
        var filter = vm.getFilter(filterKey);
        filter.setValue("");
    };

    vm.createCookie = function (name, value, days) {
            var expires;
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
    }
    
    vm.readCookie = function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1,c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length,c.length);
            }
        }
        return null;
    }

};

var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("InformaFacetDataController", ['$scope', '$rootScope', '$location', '$http', '$anchorScroll', '$timeout', 'searchService', 'searchBootstrapper', 'facetAvailabilityService', InformaFacetDataController]);